import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { buildNewsFilterUrl } from 'volto-ministerio-publico-federal/hooks/useNewsFilters';
import type { NewsByThemeData } from './schema';

export const DEFAULT_BUTTON_LABEL = 'Ver todas as notícias';

export { buildNewsFilterUrl };

export const resolveButtonHref = (
  data: NewsByThemeData = {},
): { href: string; external: boolean } => {
  const customHref = data.href?.[0]?.['@id'];

  if (data.linkMode === 'custom' && customHref) {
    return {
      href: flattenToAppURL(customHref),
      external: Boolean(data.external),
    };
  }

  return {
    href: buildNewsFilterUrl({ tema: data.tema, unidade: data.unidade }),
    external: false,
  };
};
